// import React from `react`

const t = {
  FR: {
    'register in': `Créer un compte`,
    'register out': `Fermer mon compte`,
    'Log In': 'Se connecter',
    'Log Out': 'Se déconnecter',
    connected: 'Se connecter',
    disconnected: 'Se déconnecter',

    'Try again later': `Réessayez plus tard.`,

    'Username:': `Nom d'utilisateur :`,
    EnterUsername: `Entrer un nom d'utilisateur`,
    'Find your icons': `Trouvez vos icônes`,

    'Create account': `Créer un compte`,
    'Creation steps': `Voici les étapes de création d'un compte.`,
    ChooseUsername: `Choisissez un nom d'utilisateur`,
    ChooseIcons: `Choisissez 3 icônes à mémoriser`,
    ConfirmIcons: `Confirmez vos icônes`,
    FindIcons: `Trouvez vos icônes`,
    ShowIcons: `Voici vos icônes.`,
    Succeeded: `Vous avez réussi`,
    Failed: `Vous avez raté`,
    challengeExplanations: <>
      <p className='registerText'>
          Continuons... Dans la prochaine étape, la grille d'icônes vous sera présentée 8 fois de suite. Il se peut que vos icônes ne soient pas tous présents, voire tous absents.
      </p>
      <p className='registerText'>
          Ne cliquez QUE vos icônes. S'il n'y en a aucun, n'en cliquez aucun, car il s'agira probablement de la bonne réponse.
      </p>
    </>,
    Challenge: `Trouvez-les plusieurs fois!`,
    None: `Aucun`,
    AttempsValidation: `Validation des essais`,
    UseIcons: `Utilisez ces icônes`,
    ChangeIcons:`Changer d'icônes`,
    FinalStep: `Étape finale`,
    Warning: <p className='registerText'>
        <b>ATTENTION!</b> - Il n'y a pas de fonction de récupération d'icônes oubliés.
    </p>,
    Welcome: <>
      <p className='registerText'>En créant le compte, vous serez connecté immédiatement.</p>
      <p className='registerText'>Bienvenue sur incohérences!</p>
    </>,
    CreateAccount: `Créer le compte`,
    Connect: `Se connecter`,
    Connecting: `Connection en cours...`,

  },
  EN: {
    'register in': `Create an account`,
    'register out': `Close my account`,
    'Log In': 'Log In',
    'Log Out': 'Log Out',
    connected: 'Log In',
    disconnected: 'Log Out',

    'Try again later': `Try again later.`,
    
    'Username:': `Username :`,
    EnterUsername: `Enter a username`,
    'Find your icons': `Find your icons`,

    'Create account': `Create an account`,
    'Creation steps': `Here are the steps to create an account.`,
    ChooseUsername: `Choose a username`,
    ChooseIcons: `Choose 3 icons to memorize`,
    ConfirmIcons: `Confirm your icons`,
    FindIcons: `Find your icons`,
    ShowIcons: `Here are your icons.`,
    Succeeded: `You have succeeded`,
    Failed: `You have failed`,
    challengeExplanations: <>
      <p className='registerText'>
          Let's continue... In the next step, the icon grid will be presented to you 8 times in a row. Your icons may not all be present, or may even all be absent.
      </p>
      <p className='registerText'>
          Click ONLY your icons. If there are none, don't click any, as that will likely be the correct answer.
      </p>
    </>,
    Challenge: `Find them multiple times!`,
    None: `None`,
    AttempsValidation: `Validation of tests`,
    UseIcons: `Use these icons`,
    ChangeIcons:`Change icons`,
    FinalStep: `Final stage`,
    Warning: <p className='registerText'>
      <b>PLEASE NOTE!</b> - There is no recovery feature for forgotten icons.
    </p>,
    Welcome: <>
      <p className='registerText'>By creating an account, you will be logged in immediately.</p>
      <p className='registerText'>Welcome to Incohérences!</p>
    </>,
    CreateAccount: `Create account`,
    Connect: `Log in`,
    Connecting: `Connecting...`,

  },
  ES: {
    'register in': `Crear una cuenta`,
    'register out': `Cerrar mi cuenta`,
    'Log In': 'Acceso',
    'Log Out': 'Finalizar la sesión',
    connected: 'Acceso',
    disconnected: 'Finalizar la sesión',

    'Try again later': `Inténtelo de nuevo más tarde.`,
    
    'Username:': `Nombre de usuario:`,
    EnterUsername: `Introduzca un nombre de usuario`,
    'Find your icons': `Encuentra tus iconos`,

    'Create account': `Crear una cuenta`,
    'Creation steps': `Estos son los pasos para crear una cuenta.`,
    ChooseUsername: `Elige un nombre de usuario`,
    ChooseIcons: `Elige 3 iconos para memorizar`,
    ConfirmIcons: `Confirma tus iconos`,
    FindIcons: `Encuentra tus iconos`,
    ShowIcons: `Aquí están tus iconos.`,
    Succeeded: `Tuviste éxito`,
    Failed: `Te lo perdiste`,
    challengeExplanations: <>
      <p className='registerText'>
          Continuemos... En el siguiente paso, la cuadrícula de iconos se mostrará 8 veces seguidas. Es posible que no todos los iconos estén presentes, o incluso que no estén todos.
      </p>
      <p className='registerText'>
          Haga clic SOLO en los iconos. Si no hay ninguno, no haga clic en ninguno, ya que probablemente sea la respuesta correcta.
      </p>
    </>,
    Challenge: `¡Encuéntralos varias veces!`,
    None: `Ninguno`,
    AttempsValidation: `Validación de pruebas`,
    UseIcons: `Utilice estos iconos`,
    ChangeIcons:`Cambiar iconos`,
    FinalStep: `Etapa final`,
    Warning: <p className='registerText'>
      <b>¡ATENCIÓN!</b> - No hay función de recuperación para íconos olvidados.
    </p>,
    Welcome: <>
      <p className='registerText'>Al crear una cuenta, iniciará sesión inmediatamente.</p>
      <p className='registerText'>¡Bienvenido a Incohérences!</p>
    </>,
    CreateAccount: `Crear una cuenta`,
    Connect: `Acceso`,
    Connecting: `Conectando...`,

  },
  PT: {
    'register in': `Criar uma conta`,
    'register out': `Fechar minha conta`,
    'Log In': 'Registrar-se',
    'Log Out': 'Sair',
    connected: 'Entrar',
    disconnected: 'Sair',

    'Try again later': `Tente novamente mais tarde.`,

    'Username:': 'Usuário:',
    EnterUsername: `Digite um nome de usuário`,
    'Find your icons': `Encontre seus ícones`,

    'Create account': `Criar uma conta`,
    'Creation steps': `Aqui estão os passos para criar uma conta.`,
    ChooseUsername: `Escolha um nome de usuário`,
    ChooseIcons: `Escolha 3 ícones para memorizar`,
    ConfirmIcons: `Confirme seus ícones`,
    FindIcons: `Encontre seus ícones`,
    ShowIcons: `Aqui estão seus ícones.`,
    Succeeded: `Você conseguiu`,
    Failed: `Você perdeu`,
    challengeExplanations: <>
      <p className='registerText'>
          Vamos continuar... Na próxima etapa, a grade de ícones será apresentada 8 vezes seguidas. Seus ícones podem não estar todos presentes ou podem até estar ausentes.
      </p>
      <p className='registerText'>
          Clique SOMENTE nos seus ícones. Se não houver nenhum, não clique em nenhum, pois essa provavelmente será a resposta correta.
      </p>
    </>,
    Challenge: `Encontre-os várias vezes!`,
    None: `Nenhum`,
    AttempsValidation: `Validação de testes`,
    UseIcons: `Use estes ícones`,
    ChangeIcons:`Alterar ícones`,
    FinalStep: `Fase final`,
    Warning: <p className='registerText'>
      <b>ATENÇÃO!</b> - Não há recurso de recuperação para ícones esquecidos.
    </p>,
    Welcome: <>
      <p className='registerText'>Ao criar uma conta, você será conectado imediatamente.</p>
      <p className='registerText'>Bem-vindo ao Incohérences!</p>
    </>,
    CreateAccount: `Criar uma conta`,
    Connect: `Conecte-se`,
    Connecting: `Conectando...`,

  },
}

export default t